<script setup>
import {ref} from "vue";
import {useDataTable} from '@/utils/datatableHelper';
import Button from "../../components/forms/Button.vue";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import {useToast} from "vue-toastification";
import DocumentTemplateCategoryService from '@/services/DocumentTemplateCategoryService';
import CreateDocumentTemplateCategoryModal from '@/components/modals/CreateDocumentTemplateCategoryModal.vue';
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const toast = useToast();
const isLoading = ref(false);
// nastavení tabulky (stránka, počet řádků, řazení, filtry) se pamatuje v localStorage pod klíčem DOCUMENT-TEMPLATE-CATEGORIES-INDEX
const datatableRef = ref(null);
const datatable = useDataTable(fetchDocumentTemplateCategories, 'fullname', 10, true, {}, 'DOCUMENT-TEMPLATE-CATEGORIES-INDEX', datatableRef);
const rows = ref([]);
const columns = ref([
  {label: t('documentTemplateCategoriesIndex.name'), field: 'name', filterOptions: {enabled: false, skipDiacritics: true, placeholder: t('documentTemplateCategoriesIndex.filter_by_name')}},
  {label: '', field: 'action', sortable: false, html: true},
]);

function fetchDocumentTemplateCategories(body) {
  DocumentTemplateCategoryService.fetchRecords(body).then(response => {
    datatable.totalRecords.value = response.meta.total;
    rows.value = response.data;
  });
}

function createEditDocumentTemplateCategory(category = null) {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateDocumentTemplateCategoryModal, {category});
  reveal();
  onConfirm((data) => {
    DocumentTemplateCategoryService.saveDocumentTemplateCategory(data).then(response => {
      toast.success(response.message);
      fetchDocumentTemplateCategories(datatable.body);
    });
  });
  onCancel(() => {
  });
}
</script>

<template>
  <div class="page-section">
    <div class="page-section__heading d-flex justify-content-between align-items-center">
      <div class="page-section__title">
        {{ t('documentTemplateCategoriesIndex.category') }}
      </div>
      <div class="flex justify-end">
        <Button :label="t('documentTemplateCategoriesIndex.add_category')" icon="mdi-text-box-plus" @click="createEditDocumentTemplateCategory()"></Button>
      </div>
    </div>

    <div class="page-section__content">
      <div class="mt-3">
        <vue-good-table
            ref="datatableRef"
            :sort-options="{enabled: true, initialSortBy: datatable.initialSortBy.value}"
            :columns="columns"
            :rows="rows"
            mode="remote"
            @page-change="datatable.onPageChange"
            @sort-change="datatable.onSortChange"
            @column-filter="datatable.onColumnFilter"
            @per-page-change="datatable.onPerPageChange"
            :totalRows="datatable.totalRecords.value"
            :pagination-options="{
                  enabled: true,
                  rowsPerPageLabel: t('documentTemplateCategoriesIndex.entriesPerPage'),
                  nextLabel: t('documentTemplateCategoriesIndex.next'),
                  prevLabel: t('documentTemplateCategoriesIndex.previous'),
                  ofLabel: 'z',
                }">
          <template #table-row="props">
          <span v-if="props.column.field === 'action'">
            <span style="font-weight: bold; float: right">
                <button @click="createEditDocumentTemplateCategory(props.row)" type="button" class="btn btn-primary"><i class="mdi mdi-eye"/></button>
            </span>
          </span>
          </template>
          <template v-slot:emptystate v-if="!isLoading">
            <div class="text-center">
              {{ t('documentTemplateCategoriesIndex.no_records_found') }}
            </div>
          </template>
          <template v-slot:emptystate v-if="isLoading">
            <div class="text-center">
              {{ t('documentTemplateCategoriesIndex.data_loading') }}
            </div>
          </template>
        </vue-good-table>
      </div>
    </div>

  </div>
</template>

<style scoped>

</style>
